import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PercentagePipe } from './percentage.pipe';
import { IConfig, NgxMaskModule } from 'ngx-mask';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = {}

@NgModule({
  declarations: [
    PercentagePipe
  ],
  imports: [
    CommonModule,    
    NgxMaskModule.forRoot(options),
  ],
  exports : [
    PercentagePipe,
    NgxMaskModule
  ]
})
export class PipesModule { }
